import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'SelectedMeterComp',
  components: {
  },
  props: {
    dataObj: {
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {}
  },
  computed: {
    meterStatusColor: function () {
      if(this.dataObj.connectionStatus == 0)
        return 'not-installed-meter';
      if (this.dataObj.connectionStatus == 1)
        return 'connected-meter';
      else
        return 'disconnected-meter';
    }
  },
  created() { },
  methods: { },
}

